var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { styled } from '@mui/material';
import { Container, ContainerPaddings, ContainerDisplays, ContainerWidths, ContainerFlexDirections, ContainerPositions, ContainerHeights, ContainerFlexJustifyContents, ContainerFlexAlignItems } from '../../../../templates/container';
import { Slider, SliderNavigationPositions, SliderThemes, SliderSpecificSlidesPerViewProps } from '../../../../templates/slider';
import { Image } from '../../../../atoms/image';
import { IconButton, IconButtonSize, IconButtonStyles } from '../../../../atoms/icon-button';
import { Spacer, SpacerBorderColors, SpacerHeights } from '../../../../atoms/spacer';
import { getColumnWidth, ThemeUtils } from '../../../../../utils';
import { VideoModal, ZoomModal } from './modals';
var VideoPoster = function (_a) {
    var dataIndex = _a.dataIndex, playButtonSize = _a.playButtonSize, videoPosterPlayButtonAriaLabel = _a.videoPosterPlayButtonAriaLabel, imageAsset = _a.imageAsset, _b = _a.zoomGallery, zoomGallery = _b === void 0 ? false : _b;
    var configBC = {
        display: ContainerDisplays.Flex,
        position: ContainerPositions.Absolute,
        width: ContainerWidths.Full,
        height: ContainerHeights.Full,
        flexAlignItems: ContainerFlexAlignItems.Center,
        flexJustifyContent: ContainerFlexJustifyContents.Center,
        className: 'video-poster-container',
        'data-index': dataIndex
    };
    var configIBPlay = __assign({ size: playButtonSize, style: IconButtonStyles.Basic, icon: 'pmi-icon-play', className: 'play-button', 'data-index': dataIndex }, (videoPosterPlayButtonAriaLabel
        ? { 'aria-label': videoPosterPlayButtonAriaLabel }
        : { 'aria-label': 'pmi-icon-play' }));
    var configWrapperContainerZoomGallery = {
        className: 'zoom-poster-container',
        display: ContainerDisplays.Flex,
        position: ContainerPositions.Relative
    };
    if (zoomGallery) {
        return (React.createElement(Container, __assign({}, configWrapperContainerZoomGallery),
            React.createElement(Container, __assign({}, configBC),
                React.createElement(IconButton, __assign({}, configIBPlay))),
            React.createElement(Image, __assign({}, imageAsset))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, __assign({}, configBC),
            React.createElement(IconButton, __assign({}, configIBPlay))),
        React.createElement(Image, __assign({}, imageAsset))));
};
var MuiImageGalleryContainer = styled(Container, {
    name: 'MuiImageGalleryContainer',
    overridesResolver: function (wrapperProps, styles) { return [styles.root]; }
})({});
var ImageSliderWrapper = function (sliderConfig) {
    var wrapperConfig = {
        height: ContainerHeights.Full,
        width: ContainerWidths.Full
    };
    return (React.createElement(MuiImageGalleryContainer, __assign({}, wrapperConfig),
        React.createElement(Slider, __assign({}, sliderConfig))));
};
var MuiImageGalleryThumbnails = styled(Container, {
    name: 'MuiImageGalleryThumbnails',
    overridesResolver: function (wrapperProps, styles) { return [styles.root]; }
})({});
var ZoomGallerySlider = function (_a) {
    var props = __rest(_a, []);
    var configZoomModal = props.configZoomModal, configPosterSliderZoom = props.configPosterSliderZoom, configThumbsZoomSlider = props.configThumbsZoomSlider;
    var slides = configThumbsZoomSlider.slides;
    return (React.createElement(ZoomModal, __assign({}, configZoomModal),
        React.createElement(Slider, __assign({}, configPosterSliderZoom)),
        React.createElement(Spacer, { spacerHeight: SpacerHeights.Size_4, spacerBorderTopTypeVariant: SpacerBorderColors.None }),
        (slides === null || slides === void 0 ? void 0 : slides.length) && (slides === null || slides === void 0 ? void 0 : slides.length) > 1 && (React.createElement(MuiImageGalleryThumbnails, null,
            React.createElement(Slider, __assign({}, configThumbsZoomSlider))))));
};
var PIG = function (_a) {
    var props = __rest(_a, []);
    var gallery = props.gallery, zoomLabel = props.zoomLabel, accessibilityProps = props.accessibilityProps, onlyZoomGallery = props.onlyZoomGallery, openZoomGallery = props.openZoomGallery, setOpenZoomGallery = props.setOpenZoomGallery, background = props.background;
    var innerContainerConfig = {
        display: ContainerDisplays.Flex,
        flexDirection: ContainerFlexDirections.Column
    };
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    var _b = useState(null), thumbsSlider = _b[0], setThumbsSlider = _b[1];
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    var _c = useState(null), controlledZoomSlider = _c[0], setControlledZoomSlider = _c[1];
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    var _d = useState(null), controlledPosterSlider = _d[0], setPosterZoomSlider = _d[1];
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    var _e = useState(null), thumbsSliderZoom = _e[0], setThumbsSliderZoom = _e[1];
    var _f = useState(false), isVideoModalOpen = _f[0], setIsVideoModalOpen = _f[1];
    var _g = useState(false), isZoomModalOpen = _g[0], setIsZoomModalOpen = _g[1];
    var _h = useState(true), showZoomLabel = _h[0], setShowZoomLabel = _h[1];
    var _j = useState({}), videoProps = _j[0], setVideoProps = _j[1];
    var slidesGallery = gallery === null || gallery === void 0 ? void 0 : gallery.map(function (asset, index) {
        if (asset.videoUrl) {
            return (React.createElement(VideoPoster, { key: "video-poster-".concat(index), dataIndex: index, imageAsset: asset, playButtonSize: IconButtonSize.Large, videoPosterPlayButtonAriaLabel: accessibilityProps === null || accessibilityProps === void 0 ? void 0 : accessibilityProps.videoPosterPlayButtonAriaLabel }));
        }
        return React.createElement(Image, __assign({}, asset));
    });
    var slidesGalleryZoom = gallery === null || gallery === void 0 ? void 0 : gallery.map(function (asset, index) {
        if (asset.videoUrl) {
            return (React.createElement(VideoPoster, { key: "video-poster-".concat(index), dataIndex: index, imageAsset: __assign(__assign({}, asset), { src: asset === null || asset === void 0 ? void 0 : asset.srcFullScreen, renditions: false }), zoomGallery: true, playButtonSize: IconButtonSize.Large, videoPosterPlayButtonAriaLabel: accessibilityProps === null || accessibilityProps === void 0 ? void 0 : accessibilityProps.videoPosterPlayButtonAriaLabel }));
        }
        var configZoomContainer = {
            className: 'swiper-zoom-container',
            display: ContainerDisplays.Flex,
            width: ContainerWidths.Full,
            height: ContainerHeights.Full,
            flexAlignItems: ContainerFlexAlignItems.Center,
            flexJustifyContent: ContainerFlexJustifyContents.Center
        };
        return (React.createElement(Container, __assign({}, configZoomContainer),
            React.createElement(Image, __assign({}, __assign(__assign({}, asset), { src: asset.srcFullScreen, renditions: false })))));
    });
    var slidesGalleryThumbs = gallery === null || gallery === void 0 ? void 0 : gallery.map(function (asset, index) {
        var src = asset.src, srcThumbs = asset.srcThumbs, srcSetData = asset.srcSetData, renditions = asset.renditions, rest = __rest(asset, ["src", "srcThumbs", "srcSetData", "renditions"]);
        if (asset.videoUrl) {
            return (React.createElement(VideoPoster, { key: "video-poster-".concat(index), dataIndex: index, imageAsset: __assign(__assign({}, rest), { src: srcThumbs }), playButtonSize: IconButtonSize.Small, videoPosterPlayButtonAriaLabel: accessibilityProps === null || accessibilityProps === void 0 ? void 0 : accessibilityProps.videoPosterPlayButtonAriaLabel }));
        }
        return React.createElement(Image, __assign({}, rest, { src: srcThumbs }));
    });
    var configPosterSliderBase = __assign({ navigationConfig: {
            width: ThemeUtils.getResponsiveProp([getColumnWidth(12, 12)]),
            padding: ThemeUtils.getResponsiveProp([{ x: ContainerPaddings.Size_5 }]),
            disabledButtons: true
        }, navigationPosition: SliderNavigationPositions.Mid, keyboard: true, autoHeight: false, centeredSlides: true, sliderTheme: SliderThemes.Dark, slideToClickedSlide: true, sliderWidths: ContainerWidths.Full, numberOfColumns: ThemeUtils.getResponsiveProp([getColumnWidth(12, 12)]), propsPerBreakpoints: ThemeUtils.getResponsiveProp([
            {
                slidesPerView: 1
            }
        ]), sliderPadding: ThemeUtils.getResponsiveProp([
            { l: ContainerPaddings.Size_0 }
        ]), lazyLoading: true, verticalPadding: false, className: 'slider-product-image-gallery-poster' }, ((accessibilityProps === null || accessibilityProps === void 0 ? void 0 : accessibilityProps.sliderAccessibilityProps)
        ? { accessibilityProps: accessibilityProps === null || accessibilityProps === void 0 ? void 0 : accessibilityProps.sliderAccessibilityProps }
        : {}));
    var configPosterSlider = __assign(__assign(__assign({}, configPosterSliderBase), { slides: slidesGallery, thumbsConfig: {
            sliderInstance: thumbsSlider,
            thumbsContainerClass: 'poster-thumbs'
        }, controller: { control: controlledZoomSlider }, onSliderInit: setPosterZoomSlider, onZoom: function () {
            setIsZoomModalOpen(true);
        }, 
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        slideOnClick: function (e) {
            var _a, _b, _c, _d, _e, _f, _g;
            var selectedVideoSlide = ((_c = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b['data-index']) === null || _c === void 0 ? void 0 : _c.value) ||
                ((_g = (_f = (_e = (_d = e.target) === null || _d === void 0 ? void 0 : _d.parentElement) === null || _e === void 0 ? void 0 : _e.attributes) === null || _f === void 0 ? void 0 : _f['data-index']) === null || _g === void 0 ? void 0 : _g.nodeValue);
            if (selectedVideoSlide) {
                setVideoProps({
                    videoSrc: (gallery === null || gallery === void 0 ? void 0 : gallery[selectedVideoSlide].videoUrl) || '',
                    videoTitle: (gallery === null || gallery === void 0 ? void 0 : gallery[selectedVideoSlide].videoTitle) || ''
                });
                setIsVideoModalOpen(true);
            }
            setIsZoomModalOpen(true);
        } }), ((accessibilityProps === null || accessibilityProps === void 0 ? void 0 : accessibilityProps.zoomButtonAriaLabel)
        ? { zoomButtonAriaLabel: accessibilityProps === null || accessibilityProps === void 0 ? void 0 : accessibilityProps.zoomButtonAriaLabel }
        : {}));
    var configThumbsSliderBase = {
        slides: slidesGalleryThumbs,
        keyboard: true,
        autoHeight: false,
        verticalPadding: false,
        sliderTheme: SliderThemes.Dark,
        slideToClickedSlide: true,
        sliderWidths: ContainerWidths.Full,
        numberOfColumns: ThemeUtils.getResponsiveProp([getColumnWidth(12, 12)]),
        propsPerBreakpoints: ThemeUtils.getResponsiveProp([
            {
                slidesPerView: SliderSpecificSlidesPerViewProps.Auto,
                spaceBetween: Number(ThemeUtils.getComputedSpacing(Number(2), true))
            }
        ]),
        sliderPadding: ThemeUtils.getResponsiveProp([
            { l: ContainerPaddings.Size_0 }
        ]),
        sliderWrapperFlex: true,
        sliderOverflow: false,
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        slideOnClick: function (e) {
            var _a, _b, _c, _d, _e, _f, _g;
            var selectedVideoSlide = ((_c = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b['data-index']) === null || _c === void 0 ? void 0 : _c.value) ||
                ((_g = (_f = (_e = (_d = e.target) === null || _d === void 0 ? void 0 : _d.parentElement) === null || _e === void 0 ? void 0 : _e.attributes) === null || _f === void 0 ? void 0 : _f['data-index']) === null || _g === void 0 ? void 0 : _g.nodeValue);
            if (selectedVideoSlide) {
                setVideoProps({
                    videoSrc: (gallery === null || gallery === void 0 ? void 0 : gallery[selectedVideoSlide].videoUrl) || '',
                    videoTitle: (gallery === null || gallery === void 0 ? void 0 : gallery[selectedVideoSlide].videoTitle) || ''
                });
                setIsVideoModalOpen(true);
            }
        },
        className: 'slider-product-image-gallery-thumbs'
    };
    var configThumbsSlider = __assign(__assign({}, configThumbsSliderBase), { idThumbs: 'poster-thumbs', onSliderInit: setThumbsSlider, 
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        slideOnClick: function (e) {
            var _a, _b, _c, _d, _e, _f, _g;
            var selectedVideoSlide = ((_c = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b['data-index']) === null || _c === void 0 ? void 0 : _c.value) ||
                ((_g = (_f = (_e = (_d = e.target) === null || _d === void 0 ? void 0 : _d.parentElement) === null || _e === void 0 ? void 0 : _e.attributes) === null || _f === void 0 ? void 0 : _f['data-index']) === null || _g === void 0 ? void 0 : _g.nodeValue);
            if (selectedVideoSlide) {
                setVideoProps({
                    videoSrc: (gallery === null || gallery === void 0 ? void 0 : gallery[selectedVideoSlide].videoUrl) || '',
                    videoTitle: (gallery === null || gallery === void 0 ? void 0 : gallery[selectedVideoSlide].videoTitle) || ''
                });
                setIsVideoModalOpen(true);
            }
        } });
    var configThumbsZoomSlider = __assign(__assign({}, configThumbsSliderBase), { slides: slidesGalleryThumbs, idThumbs: 'zoom-thumbs', sliderOverflowContainer: true, onSliderInit: setThumbsSliderZoom });
    var configPosterSliderZoom = __assign(__assign({}, configPosterSliderBase), { slides: slidesGalleryZoom, sliderFullHeight: true, thumbsConfig: {
            sliderInstance: thumbsSliderZoom,
            thumbsContainerClass: 'zoom-thumbs'
        }, sliderOverflowContainer: true, 
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        slideOnClick: function (e) {
            var _a, _b, _c, _d, _e, _f, _g;
            var selectedVideoSlide = ((_c = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b['data-index']) === null || _c === void 0 ? void 0 : _c.value) ||
                ((_g = (_f = (_e = (_d = e.target) === null || _d === void 0 ? void 0 : _d.parentElement) === null || _e === void 0 ? void 0 : _e.attributes) === null || _f === void 0 ? void 0 : _f['data-index']) === null || _g === void 0 ? void 0 : _g.nodeValue);
            if (selectedVideoSlide) {
                setVideoProps({
                    videoSrc: (gallery === null || gallery === void 0 ? void 0 : gallery[selectedVideoSlide].videoUrl) || '',
                    videoTitle: (gallery === null || gallery === void 0 ? void 0 : gallery[selectedVideoSlide].videoTitle) || ''
                });
                setIsVideoModalOpen(true);
            }
            setShowZoomLabel(false);
        }, onSliderInit: setControlledZoomSlider, controller: { control: controlledPosterSlider }, zoom: {
            enabled: true,
            showZoomLabel: showZoomLabel,
            setShowZoomLabel: setShowZoomLabel,
            zoomLabel: zoomLabel
        } });
    var configZoomModal = __assign(__assign({ isZoomModalOpen: openZoomGallery || isZoomModalOpen, setIsZoomModalOpen: setIsZoomModalOpen, setThumbsSliderZoom: setThumbsSliderZoom, setOpenZoomGallery: setOpenZoomGallery }, ((accessibilityProps === null || accessibilityProps === void 0 ? void 0 : accessibilityProps.dialogCloseButtonAriaLabel)
        ? {
            dialogCloseButtonAriaLabel: accessibilityProps.dialogCloseButtonAriaLabel
        }
        : {})), { background: background });
    var configVideoModal = __assign({ isOpen: isVideoModalOpen, setIsOpen: setIsVideoModalOpen, videoProps: videoProps }, ((accessibilityProps === null || accessibilityProps === void 0 ? void 0 : accessibilityProps.dialogCloseButtonAriaLabel)
        ? {
            dialogCloseButtonAriaLabel: accessibilityProps.dialogCloseButtonAriaLabel
        }
        : {}));
    var configZoomGallerySlider = {
        configZoomModal: configZoomModal,
        configPosterSliderZoom: configPosterSliderZoom,
        configThumbsZoomSlider: configThumbsZoomSlider
    };
    if (onlyZoomGallery) {
        return (React.createElement(React.Fragment, null,
            React.createElement(ZoomGallerySlider, __assign({}, configZoomGallerySlider)),
            React.createElement(VideoModal, __assign({}, configVideoModal))));
    }
    var thumbsContainerConfig = {
        height: ContainerHeights.Full
    };
    return (React.createElement(Container, null,
        React.createElement(Container, __assign({}, innerContainerConfig),
            slidesGallery && (slidesGallery === null || slidesGallery === void 0 ? void 0 : slidesGallery.length) > 0 && (React.createElement(React.Fragment, null,
                React.createElement(ImageSliderWrapper, __assign({}, configPosterSlider)),
                React.createElement(Spacer, { spacerHeight: SpacerHeights.Size_4, spacerBorderTopTypeVariant: SpacerBorderColors.None }),
                (slidesGalleryThumbs === null || slidesGalleryThumbs === void 0 ? void 0 : slidesGalleryThumbs.length) && slidesGalleryThumbs.length > 1 && (React.createElement(MuiImageGalleryThumbnails, __assign({}, thumbsContainerConfig),
                    React.createElement(Slider, __assign({}, configThumbsSlider)))))),
            React.createElement(ZoomGallerySlider, __assign({}, configZoomGallerySlider)),
            React.createElement(VideoModal, __assign({}, configVideoModal)))));
};
export { PIG as ProductImageGallery };
